/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Back_Take_TimeInputs */

const fr_welcome_back_take_time = /** @type {(inputs: Welcome_Back_Take_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensez néanmoins à prendre quelques minutes de votre temps afin de prendre vos repères.`)
};

const en_welcome_back_take_time = /** @type {(inputs: Welcome_Back_Take_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still, take a few minutes to find your bearings.`)
};

/**
* | output |
* | --- |
* | "Still, take a few minutes to find your bearings." |
*
* @param {Welcome_Back_Take_TimeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const welcome_back_take_time = /** @type {((inputs?: Welcome_Back_Take_TimeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_Take_TimeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome_back_take_time(inputs)
	return en_welcome_back_take_time(inputs)
});